import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveGallerySingle } from "@website/widget/reserve-gallery-detail/reserve-gallery-single";
import { ReserveGalleryDetailContainer } from "@website/widget/reserve-gallery/reserve-gallery-detail-container";
import { useReserveGallery } from "@website/widget/reserve-gallery/reserve-gallery.hook";
import { ReserveGalleryPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery.types";
import { useRouter } from "next/router";
export const ReserveGallery = properties => {
  const $ = _c(21);
  const router = useRouter();
  const {
    isMobile,
    isDesktop
  } = useViewPort();
  const {
    gallery
  } = properties;
  const {
    imagesProps,
    detailProps,
    singleProps,
    moreProps
  } = useReserveGallery(properties);
  if (!gallery?.length) {
    return null;
  }
  let t0;
  if ($[0] !== imagesProps) {
    t0 = imagesProps?.map(_temp);
    $[0] = imagesProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = isMobile && gallery?.length > 1 || isDesktop && gallery?.length > 5;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="apps" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== gallery.length || $[4] !== router.locale) {
    t3 = numberConvert(gallery.length, {
      locale: router.locale
    });
    $[3] = gallery.length;
    $[4] = router.locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${t3} تصویر در گالری`;
  let t5;
  if ($[6] !== moreProps || $[7] !== t4) {
    t5 = <Button StartIcon={t2} className="!absolute bottom-4 end-4 flex" {...moreProps}>{t4}</Button>;
    $[6] = moreProps;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t5) {
    t6 = <div className="relative grid grid-cols-1 grid-rows-1 gap-2 overflow-hidden md:h-[360px] md:w-full md:grid-cols-4 md:grid-rows-2 md:rounded-xl xl:h-[400px]" id="hotel_gallery">{t0}{t1}{t5}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== detailProps) {
    t7 = <ReserveGalleryDetailContainer {...detailProps} />;
    $[13] = detailProps;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== singleProps) {
    t8 = <ReserveGallerySingle {...singleProps} />;
    $[15] = singleProps;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
function _temp(t0, index) {
  const {
    imageProps,
    containerProps
  } = t0;
  return <div key={containerProps?.key} itemScope={true} {...containerProps} className={`${containerProps.className} hidden first:block md:block`}><LazyImage {...imageProps} className="bg-outline-thin h-[200px] w-full object-cover md:h-full" fallback={FALLBACK_IMAGE_MD.src} loading={index === 0 ? "eager" : "lazy"} /></div>;
}